<template src="./index.html"></template>

<script>
import {getdata} from "./data.js";
import {queryCompanyList} from "../../../../../../api/home.js";
import config from "../../../../../../../configHttp.js";

export default {
  data: function () {
    return {
      headData: getdata().headData,
      searchdiag: false,
      searchlist: getdata().searchlist,
      dateValue: "",
      searchdata: getdata().searchdata,
      tableData: [],
      pagination: getdata().pagination,
      tablekey: 0,
      overlength: 0,
    };
  },
  mounted() {
    this.loadHeadData()
  },
  created() {
    this.fetchBillDetails();
  },
  components: {},
  methods: {
    loadHeadData() {
      queryCompanyList().then(res => {
        if (res.data.code === 1) {
          let companyCodeVal = [];
          for (let i = 0; i < res.data.data.length; i++) {
            companyCodeVal.push({label: res.data.data[i].companyCode, value: res.data.data[i].companyCode})
          }
          this.searchlist[2].selectval = companyCodeVal;
          this.searchlist = JSON.parse(JSON.stringify(this.searchlist));
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    fetchBillDetails() {
      let params = JSON.parse(JSON.stringify(this.searchdata));
      params.current = this.pagination.pageNum;
      params.size = this.pagination.pageSize;
      params.sort = "createTime";
      params.order = "desc";
      // xxzzs_mxquery(params).then((res) => {
      //   this.pagination.total = res.data.data.total;
      //   this.pagination.paginationkey++;
      //   this.tableData = res.data.data.records;
      // });
    },
    outPutIInvResult() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      let data = {};
      if (selectVal.length > 0) {
        data.ids = selectVal.map((item) => item.id);
      } else {
        data.fapiaoInfoSearchExtendInputDTO = JSON.parse(JSON.stringify(this.searchdata));
      }
      let params = {
        downUrl: config.baseURL + "oinv/details/export",
        typeObj: {
          toForm: false,
          fileName: "销项增值税票据明细" + this.$timestampToStr(new Date(), "yyyyMMdd"),
          fileType: "xlsx",
          failUrl: this.$winURl
        },
        params: data,
      };
      this.$downloadcommon(params);
    },
    geOoverLength(e) {
      this.overlength = e;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.fetchBillDetails();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.fetchBillDetails();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchBillDetails();
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
